import i18n from '../translations'
import { IncomingSelfBillingOrder, IncomingSelfBillingOrderStatus, IncomingSelfBillingOrderType } from '../types'
import moment from '../utilities/Moment'

export default class IncomingSelfBillingOrderHelper {
  static getTypeLabel(type: IncomingSelfBillingOrderType = IncomingSelfBillingOrderType.INVOICE): string {
    return i18n.t(`IncomingSelfBillingOrderType::${type}`)
  }

  static isPaid(order: IncomingSelfBillingOrder): boolean {
    return order.paid_on !== null
  }

  static isOverdue(order: IncomingSelfBillingOrder): boolean {
    if (order.due_date && !this.isPaid(order)) {
      return moment().isAfter(moment(order.due_date), 'day')
    }
    return false
  }


  static getStatus(order: IncomingSelfBillingOrder): IncomingSelfBillingOrderStatus {
    if (order.type === IncomingSelfBillingOrderType.INVOICE) {
      const isPaid = this.isPaid(order)
      const isOverdue = this.isOverdue(order) && !isPaid

      if (isPaid) {
        return IncomingSelfBillingOrderStatus.PAID
      } else if (isOverdue) {
        return IncomingSelfBillingOrderStatus.OVERDUE
      } else

        return IncomingSelfBillingOrderStatus.OUTSTANDING
    } else if (order.type === IncomingSelfBillingOrderType.CREDIT_NOTE) {

      return IncomingSelfBillingOrderStatus.CREDITED
    } else {
      throw Error(`[getStatus] invalid type ${order.type} given.`)
    }
  }

  static getStatusLabel(status: IncomingSelfBillingOrderStatus): string {
    return i18n.t(`IncomingSelfBillingOrderStatus::${status}`)
  }
}

